module.exports = __webpack_public_path__ + "static/img/guide1.dd5d47a2.png";